import Vue from 'vue';
import Router from 'vue-router';

// Components
import Home from '@/components/Home.vue';
import Greeting from '@/components/Greeting.vue';
import About from '@/components/About.vue';
import Info from '@/components/Info.vue';
import Post from '@/components/Post/Post.vue';
import PostPreview from '@/components/Post/PostPreview.vue';
import Page from '@/components/Page/Page.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/greeting',
      name: 'Greeting',
      component: Greeting,
    },
    {
      path: '/about',
      name: 'About',
      component: About,
    },
    {
      path: '/info',
      name: 'Info',
      component: Info,
    },
    {
      path: '/news/:year/:month/:day/:postSlug',
      name: 'Post',
      component: Post,
    },
    {
      path: '/en/news/:year/:month/:day/:postSlug',
      name: 'Post',
      component: Post,
    },
    {
      path: '/news/preview',
      name: 'PostPreview',
      component: PostPreview,
    },
    {
      path: '/:pageSlug',
      name: 'Page',
      component: Page,
    },
  ],
  mode: 'history',
  base: '',

  // Prevents window from scrolling back to top
  // when navigating between components/views
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
